// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets//backGround.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topHeader{
    width: 100%;
    height: fit-content;
    display: flex;
    align-items: center;
}
 
.header-container h1{
    font-size: 30px;
    font-weight: 600;
    color: #000000;
    text-transform: capitalize;
}

.sideToggleIcon{
    display: none;
}

#addNewsBtn{
    width: 167px;
    height: 38px !important;
}

.custom_btn {
    border: none;
    padding: 0;
    
    
}
.close_button {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

/* Profile Icon Css */
.profile {
    margin: 0 !important;
    padding-right: 25px;
    padding-bottom: 9px;
    padding-left: 22px;
}

.logout {
    margin: 0 !important;
    padding: 0 !important;
    top: 44px;
    right: 20px;
    background: var(--color-main-color-white, #FFFFFF);
    border-radius: 4px;
    padding: 8px 38px 8px 25px !important;
    box-shadow: 5px 6px 10.3px 0px #0000002B;
    transition: max-height 0.4s ease-out,opacity 0.4s ease-out;
    max-height: 0;
    overflow: hidden;
    opacity: 0;
}

.logout.open {
    max-height: 300px;
    opacity: 1;
    transition: max-height 0.5s ease-out, opacity 0.5s ease-out;
}

.profile_btn {
    margin-left: 1rem;
    align-items: center;
    gap: 7px;
    font-family: Quicksand;
    font-size: 18px;
    font-weight: 600;
    line-height: 20px;
    color: #234B9A;
    text-align: left;
}
.sorttablebtnn >ul>li:hover{
    background: #eceaea !important;
}

.modal-title{
    font-weight: 600 !important;
}

.custom-modal .modal-content {
    border-radius: 15px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-repeat: no-repeat;
    padding: 20px;
}



.modal-header-custom.modal-header {
    flex-direction: column-reverse;
}

.modal-content {
    padding: 0 !important;
}

.modal-footer {
    padding: 21px 27px !important;
    flex-wrap: nowrap !important;
    gap: 24px;
}


.cancel-button {
    width: 52% !important;
    background: transparent !important;
    color: black !important;
    box-shadow: none !important;
    border: 2px solid #234B9A !important;
}

.logout-button {
    width: 53% !important;
}

.modal-header-custom {
    border-bottom: none; /* Remove border at the bottom of header */
   
}


.modal-footer {
    border-top: none; /* Remove border at the top of footer */
   
}

@media screen and (max-width:851px) {
    .sideToggleIcon{
        display: block;
    }
}
@media screen and (max-width:500px) {
    #addNewsBtn{
        width: 180px;
    }
}

.change-pwd{
    width: 14rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Header/Header.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,UAAU;;;AAGd;AACA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,SAAS;IACT,WAAW;IACX,kDAAkD;IAClD,kBAAkB;IAClB,qCAAqC;IACrC,wCAAwC;IACxC,0DAA0D;IAC1D,aAAa;IACb,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,2DAA2D;AAC/D;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,yDAAwD;IACxD,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;AACjB;;;;AAIA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,SAAS;AACb;;;AAGA;IACI,qBAAqB;IACrB,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB,EAAE,0CAA0C;;AAEnE;;;AAGA;IACI,gBAAgB,EAAE,uCAAuC;;AAE7D;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".topHeader{\n    width: 100%;\n    height: fit-content;\n    display: flex;\n    align-items: center;\n}\n \n.header-container h1{\n    font-size: 30px;\n    font-weight: 600;\n    color: #000000;\n    text-transform: capitalize;\n}\n\n.sideToggleIcon{\n    display: none;\n}\n\n#addNewsBtn{\n    width: 167px;\n    height: 38px !important;\n}\n\n.custom_btn {\n    border: none;\n    padding: 0;\n    \n    \n}\n.close_button {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n}\n\n/* Profile Icon Css */\n.profile {\n    margin: 0 !important;\n    padding-right: 25px;\n    padding-bottom: 9px;\n    padding-left: 22px;\n}\n\n.logout {\n    margin: 0 !important;\n    padding: 0 !important;\n    top: 44px;\n    right: 20px;\n    background: var(--color-main-color-white, #FFFFFF);\n    border-radius: 4px;\n    padding: 8px 38px 8px 25px !important;\n    box-shadow: 5px 6px 10.3px 0px #0000002B;\n    transition: max-height 0.4s ease-out,opacity 0.4s ease-out;\n    max-height: 0;\n    overflow: hidden;\n    opacity: 0;\n}\n\n.logout.open {\n    max-height: 300px;\n    opacity: 1;\n    transition: max-height 0.5s ease-out, opacity 0.5s ease-out;\n}\n\n.profile_btn {\n    margin-left: 1rem;\n    align-items: center;\n    gap: 7px;\n    font-family: Quicksand;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 20px;\n    color: #234B9A;\n    text-align: left;\n}\n.sorttablebtnn >ul>li:hover{\n    background: #eceaea !important;\n}\n\n.modal-title{\n    font-weight: 600 !important;\n}\n\n.custom-modal .modal-content {\n    border-radius: 15px;\n    background-image: url('../../../assets//backGround.png');\n    background-position: center;\n    background-repeat: no-repeat;\n    padding: 20px;\n}\n\n\n\n.modal-header-custom.modal-header {\n    flex-direction: column-reverse;\n}\n\n.modal-content {\n    padding: 0 !important;\n}\n\n.modal-footer {\n    padding: 21px 27px !important;\n    flex-wrap: nowrap !important;\n    gap: 24px;\n}\n\n\n.cancel-button {\n    width: 52% !important;\n    background: transparent !important;\n    color: black !important;\n    box-shadow: none !important;\n    border: 2px solid #234B9A !important;\n}\n\n.logout-button {\n    width: 53% !important;\n}\n\n.modal-header-custom {\n    border-bottom: none; /* Remove border at the bottom of header */\n   \n}\n\n\n.modal-footer {\n    border-top: none; /* Remove border at the top of footer */\n   \n}\n\n@media screen and (max-width:851px) {\n    .sideToggleIcon{\n        display: block;\n    }\n}\n@media screen and (max-width:500px) {\n    #addNewsBtn{\n        width: 180px;\n    }\n}\n\n.change-pwd{\n    width: 14rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
